module.exports = __webpack_public_path__ + "img/team.624c26c8.png";